/**
 * THE one status axis every Claudia conversation surface renders (nav flyout, panel tab, list
 * screen).
 *
 * Working / Needs you / Idle is a *derivation*, not stored state — the backend computes it from
 * the discovery row's run pointer, the owner's read marker and the project's pending `ask_user`
 * set, and ships only the result. The members live here because both ends spell them: the
 * derivation names them and the browser renders them as a column, a filter and a mark.
 */
/**
 * `working` — Claudia is generating; nothing is required from the reader.
 * `needs_you` — she stopped and something is waiting: a question, an approval, or an unread
 *   reply. Deliberately not split, because the reader has to open the conversation either way.
 * `idle` — up to date and read.
 */
export const CONVERSATION_STATUSES = ["working", "needs_you", "idle"];
/**
 * Why a conversation is in its status, for the row's second line.
 *
 * The reason is `null` for `working` (the activity phrase lives in `assistantRunProgress` and is
 * not worth a per-row subscription) and for `idle`, which is why the type below admits `null`
 * while the array holds only the three reasons that are ever named.
 */
export const CONVERSATION_STATUS_REASONS = [
    "awaiting_answer",
    "awaiting_approval",
    "finished_unread",
];
